/* OPTIMIZER WORLOAD */

export const GET_OPTIMIZER_WORKLOAD = "GET_OPTIMIZER_WORKLOAD";
export const GET_OPTIMIZER_WORKLOAD_SUCCESS = "GET_OPTIMIZER_WORKLOAD_SUCCESS";
export const GET_OPTIMIZER_WORKLOAD_FAIL = "GET_OPTIMIZER_WORKLOAD_FAIL";